import React, { useState } from 'react'
import Module from '../../../../layout/Module'
import { 
  Routes,
  Route,
  useParams,
  useNavigate
} from 'react-router-dom'
import NotFoundPage from '../../../../NotFoundPage/NotFoundPage'
import TabsLink from '../../../../tabs/TabsLink'
import General from '../General/General'
import AlertSaveButton from '../../../../button/AlertSaveButton'
import Levels from '../Levels/Levels'
import Marking from '../Marking/Marking'
import LcElements from '../LcElements/LcElements'
import Elements from '../Elements/Elements'
import useFetchData from '../../../../../hooks/useFetchData'
import { Typography } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import { useSelector } from 'react-redux'
import DialogCurriculum from '../Dialog/Dialog'
import ElementsStructure from '../ElementsStructure/ElementsStructure'
import TextEllipsis from '../../../../text/TextEllipsis'

const View = () => {
  const [modal, setModal] = useState(null)
  const permission = useSelector((state) => state?.session?.permissions?.curriculum)
  const navigation = useNavigate()
  const { curriculumId } = useParams()
  const { isLoading, data } = useFetchData(`curriculum/${curriculumId}`);
  const height = 34
  return (
    <>
      <Module.BodyHeader gap={0}>
        <div className='h-full flex items-center max-w-80px min-w-50px border-b border-primary' style={{height}}>
          { isLoading
            ? <Typography color="primary" className='w-8' variant='h6'> <Skeleton /></Typography>
            : <TextEllipsis id={curriculumId} children={data?.shortName} className='text-xl font-bold text-primary' />
          }
        </div>
        <div className='relative overflow-hidden w-full h-full flex items-end'>
          <TabsLink
            id='curriculum'
            items={[
              { id: 'general', name: 'General', path: `/dashboard/curriculum/${curriculumId}`, permission: true, end: true },
              { id: 'level', name: 'Levels', path: `/dashboard/curriculum/${curriculumId}/levels`, permission: true, end: true },
              { id: 'marking', name: 'Marking', path: `/dashboard/curriculum/${curriculumId}/marking`, permission: true, end: true },
              { id: 'elements-structure', name: 'Structure', path: `/dashboard/curriculum/${curriculumId}/elements-structure`, permission: true },
              { id: 'elements', name: 'Elements', path: `/dashboard/curriculum/${curriculumId}/elements`, permission: true },
              { id: 'lc-elements', name: 'Lc Elements', path: `/dashboard/curriculum/${curriculumId}/lc-elements`, permission: true, end: true },
            ]} 
          />
        </div>
        <div className='h-full flex items-center gap-4 border-b border-primary pl-2' style={{height}}>
          { permission.deleted &&
            <IconTooltipButton
              id={`delete-${curriculumId}`}
              disabled={isLoading}
              title='Delete'
              icon='trash-alt'
              style={{
                borderRadius: '0.5rem',
                backgroundColor: '#fff',
                color: 'var(--destructive)',
                padding: '0.45rem',
              }}
              className="shadow-sm"
              onClick={() => setModal(true)}
            />
          }
          <AlertSaveButton
            submodule='Curriculum'
            icon={['fal', 'times']}
            title='Cancel'
            color='primary'
            disabled={isLoading}
            variant='outlined'
            className='shadow-sm'
            onDontSave={() => navigation(`/dashboard/curriculum`)}
          />
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        <Routes>
          <Route index element={<General isLoading={isLoading} data={data} />} />
          <Route path="levels" element={<Levels />} />
          <Route path="marking" element={<Marking />} />
          <Route path="lc-elements" element={<LcElements />} />
          <Route path="elements/*" Component={Elements} />
          <Route path="elements-structure" element={<ElementsStructure />} />
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      </Module.BodyContainer>
      { modal && (
        <DialogCurriculum
          show={!!modal}
          type="delete"
          data={data}
          onClose={() => setModal(null)}
        />
      )}
    </>
  )
}

export default View;
